import { createBrowserRouter } from "react-router-dom";

import Login from "../pages/Login/Login"
import Votes from "../pages/Votes/Votes"
import Protected from "../components/Protected";
import Ballot from "../pages/Ballot/Ballot";
import UserManagement from "../pages/UserManagement/UserManagement";
import Vote from "../pages/Vote/Vote";
import CreateVote from "../pages/CreateVote/CreateVote";
import VoteHistory from "../pages/VoteHistory/VoteHistory";
import Handrules from "../pages/Handrules/Handrules"
import Profile from "../pages/Profile/Profile";
import Test from "../Test";
import Costelgpt from "../pages/Costelgpt/Costelgpt";
import AttendanceOverview from "../pages/AttendanceOverview/AttendanceOverview";
import Admin from "../pages/Admin/Admin";
const router = createBrowserRouter([
    {
        path: "/test",
        element: <Protected> <Test /> </Protected>
    },
    {
        path: "/login",
        element: <Login />
    },
    {
        path: "",
        element: <Protected> <Votes /> </Protected>
    },
    {
        path: "/",
        element: <Protected> <Votes /> </Protected>
    },
    {
        path: "/ballot/:ballotId",
        element: <Protected> <Ballot /> </Protected>
    },
    {
        path: "/admin",
        element: <Protected> <Admin /> </Protected>
    },

    {
        path: "/history",
        element: <Protected> <VoteHistory /> </Protected>
    },
    {
        path: "/usermanagement",
        element: <Protected> <UserManagement /> </Protected>
    },
    {
        path: "/vote",
        element: <Protected> <Vote /> </Protected>
    },
    {
        path: "/createvote",
        element: <Protected> <CreateVote /> </Protected>
    },
    {
        path: "/handrules",
        element: <Protected> <Handrules /> </Protected>
    },
    {
        path: "/profile",
        element: <Protected> <Profile /> </Protected>
    },
    {
        path: "/profile/:uid",
        element: <Protected> <Profile /> </Protected>
    },
    {
        path: "/costelgpt",
        element: <Protected> <Costelgpt/> </Protected>
    },
    {
        path: "/attendance",
        element: <Protected><AttendanceOverview /></Protected>
    }
]);

export default router;